<template>
    <el-dialog v-model="dialogAuthVisible" title="授权" class="form-dialog" width="60%">
        <el-row class="auth-page">
            <el-col :span="24">
                <el-tree
                    ref="treeRef"
                    class="tree-box"
                    :data="menusList"
                    node-key="id"
                    default-expand-all
                    check-strictly
                    :expand-on-click-node="false"
                    :props="{ children: 'children', label: 'title', class: customNodeClass }"
                    show-checkbox
                    @check="checkData"
                >
                    <template #default="{ node, data }">
                        <div class="custom-tree-node">
                            <div class="tree-label">
                                <div class="title">
                                    <ui-icon v-if="data.icon" :type="data.icon" /> {{ node.label }}
                                </div>
                                <div>
                                    <template v-if="data.url_value">
                                        <ui-icon v-if="!data.is_auth" type="link" />
                                        <ui-icon v-else type="unlock" />
                                    </template>
                                    {{ data.url_value }}
                                </div>
                            </div>
                        </div>
                    </template>
                </el-tree>
            </el-col>
        </el-row>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogAuthVisible = false">关闭</el-button>
                <el-button type="primary" @click="onSubmit">提交</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, reactive, inject, toRaw } from 'vue'
    import Api from '@/config/api'

    export default defineComponent({
        components: {
        },
        setup() {
            const dialogAuthVisible = ref(false)
            const { proxy } = getCurrentInstance()
            const treeRef = ref()
            const checkedNode = ref()
            const editId = ref()
            const menusList = ref([])
            const urls = proxy.$router.currentRoute.value.meta.urls
            const getMenuList = () => {
                proxy.jiu.request(urls.auth).then((res, rej) => {
                    menusList.value = res.data
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }
            const customNodeClass = (data, node) => {
                if (!data.status) {
                    return 'is-penultimate'
                }
                return null
            }
            const dialogFormVisible = ref(false)
            const checkData = (data, keys) => {
                checkedNode.value = keys.checkedKeys.concat(keys.halfCheckedKeys)
            }

            const edit = (val) => {
                dialogAuthVisible.value = true
                checkedNode.value = []
                getMenuList()
                getInfo(val)
            }

            const getInfo = (e) => {
                proxy.jiu.request(urls.info, { id: e }).then((res, rej) => {
                    editId.value = res.data.id
                    checkedNode.value = res.data.menu_auth
                    treeRef.value.setCheckedKeys(res.data.menu_auth)
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }
            const onSubmit = () => {
                proxy.jiu.request(urls.auth, { id: editId.value, menu_auth: checkedNode.value }, 'POST').then((res, rej) => {
                    dialogAuthVisible.value = false
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            return {
                menusList,
                customNodeClass,
                dialogAuthVisible,
                treeRef,

                getMenuList,
                checkData,
                onSubmit,
                edit
            }
        }
    })
</script>
<style>
    .auth-page .el-dialog__body{

    }
    .auth-page{
        height: 550px;
        overflow: scroll;
    }
    .auth-page .tree-box .el-tree-node__content{
        height: auto;
    }
    .auth-page .custom-tree-node{
        display: flex;
    }
    .auth-page .tree-label{
        font-size: 14px;
        line-height: 2.3;
        display: flex;
    }
    .auth-page .tree-label .title{
        margin-right: 10px;
        font-weight: bold;
    }
    .auth-page .el-tree-node.is-expanded.is-penultimate .el-tree-node__content:hover,
    .auth-page .el-tree-node.is-expanded.is-penultimate.is-current .el-tree-node__content,
    .auth-page .el-tree-node.is-expanded.is-penultimate .el-tree-node__content{
        background: #FFD5D0;
        color: #D2847B;
    }
</style>
